<template>
    <div class="default-wrap report-total">
        <div class="list">
            <div class="item income">
                <div class="title">
                    累積總收
                </div>
                <div class="content" :class="{'red': !isPositive(incomeList.income), 'blue': isPositive(incomeList.income)}">
                    <span v-if="!isPositive(incomeList.income)">
                        -
                    </span>
                    {{incomeList.income?toCurrency(Math.abs(incomeList.income)):0}}
                </div>
            </div>
            <div class="item">
                <div class="title">
                    累積支出
                </div>
                <div class="content" :class="{'red': !isPositive(incomeList.expense), 'blue': isPositive(incomeList.expense)}">
                    <span v-if="!isPositive(incomeList.expense)">
                        -
                    </span>
                    {{incomeList.expense?toCurrency(Math.abs(incomeList.expense)):0}}
                </div>
            </div>
            <div class="item">
                <div class="title">
                    代墊收入
                </div>
                <div class="content" :class="{'red': !isPositive(incomeList.quote), 'blue': isPositive(incomeList.quote)}">
                    <span v-if="!isPositive(incomeList.quote)">
                        -
                    </span>
                    {{incomeList.expense?toCurrency(Math.abs(incomeList.quote)):0}}
                </div>
            </div>
            <div class="item all">
                <div class="title">
                    收支合計
                </div>
                <div class="content" :class="{'red': !isPositive(incomeList.balance), 'blue': isPositive(incomeList.balance)}">
                    <span v-if="!isPositive(incomeList.balance)">
                        -
                    </span>
                    {{incomeList.balance?toCurrency(Math.abs(incomeList.balance)):0}}
                    <financial-tips-hover :data="{billServiceFeeSum: incomeList.billServiceFeeSum, ledgerServiceFeeSum: incomeList.ledgerServiceFeeSum, holdDepositSum: incomeList.holdDepositSum, advanceIncomeSum: incomeList.advanceIncomeSum, otherSum: incomeList.otherSum}"></financial-tips-hover>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import financialTipsHover from '@/components/bussiness/widges/tips/financialTipsHover.vue';

import { mapGetters } from 'vuex'
export default {
    methods: {
        isPositive: function (value) {
            console.log(value)
            if(value){
                let result = Math.sign(value)
                if( result == 1 || result == 0){
                    return true
                }else{
                    return false
                }
            }else{
                return true
            }
        }
    },
    computed: {
        ...mapGetters({
            incomeList: 'GET_BIZ_REPORT_OVER_VIEW_INCOME_LIST',
        })
    },
    components: {
        financialTipsHover
    }
}
</script>

<style lang="scss">
.report-total{
    position: relative;
    margin-bottom: 20px;
    .list{
        display: flex;
        align-items: center;
        .item{
            position: relative;
            width: 260px;
            display: flex;
            align-items: center;
            &:after{
                content: '';
                position: absolute;
                width: 1px;
                height: 32px;
                background: #f3f3f3;
                top: 0;
                right: 60px;
            }
            &.income{
                margin-left: 50px;
            }
            &.all{
                margin-right: 0px;
                &:after{
                    display: none;
                }
            }
            >.title{
                font-size: 16px;
                margin-right: 8px;
            }
            .content{
                position: relative;
                font-size: 20px;
                font-weight: 500;
                display: flex;
                align-items: center;
                &.blue{
                    color: #3942b5;
                }
                &.red{
                    color: #fc7171;
                }
                .financial-info{
                    top: 5px;
                    .amount-info{
                        position: absolute;
                        left: -150px;
                        top: 25px;
                    }
                }
            }
            
        }
    }
    
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/financialReport/reportOverview/reportOverViewTotal.vue